import { GoogleTagManagerEvents } from "common/gtm.enums";
import { UserDto } from "core/models";
import { useEffect } from "react";

export const useGtmAuthorisation = (
  user: UserDto | undefined,
  tenantId: string | undefined
) => {
  useEffect(() => {
    if (gtm && user && tenantId) {
      gtm.push({
        event: GoogleTagManagerEvents.Authenticated,
        userId: user.id,
        tenantId,
        roles: user.roles.map(r => r.roleCode).join(",")
      });
    }
  }, [user, tenantId]);
};
